import { Menu, MenuItemProps, MoreIcon, Tooltip } from "@fluentui/react-northstar";
import React from "react";

export type OverflowMenuItem = MenuItemProps & { key: string; showInOverflow?: boolean };
interface OverflowMenuProps {
  items: OverflowMenuItem[];
  maxExposedItemsCount?: number;
}

export const OverflowMenu: React.FC<OverflowMenuProps> = ({ items, maxExposedItemsCount = 0 }) => {
  if (!items.length) {
    return null;
  }
  const { outsideItems, overflowItems } = items.reduce<{
    outsideItems: OverflowMenuItem[];
    overflowItems: OverflowMenuItem[];
  }>(
    (results, item) => {
      const copy = { ...item };
      const { showInOverflow } = copy;
      // this attribute needs removed as the fluent ui menu component will attach it to the DOM element
      delete copy.showInOverflow;
      if (showInOverflow) {
        results.overflowItems.push(copy);
      } else {
        results.outsideItems.push(copy);
      }
      return results;
    },
    { outsideItems: [], overflowItems: [] }
  );

  // move non explicit overflow items outside of max allowed range into overflow menu
  const calculatedOverflowItems = outsideItems.splice(
    maxExposedItemsCount - 1,
    outsideItems.length - maxExposedItemsCount
  );
  overflowItems.unshift(...calculatedOverflowItems);

  if (overflowItems.length) {
    outsideItems.push({
      key: "overflow",
      icon: (
        <Tooltip content="Management Controls" position="above">
          <MoreIcon />
        </Tooltip>
      ),
      indicator: false,
      menu: overflowItems,
    });
  }
  return (
    <div>
      <Menu iconOnly items={outsideItems} />
    </div>
  );
};
